import { LdfTestCaseEvaluationHandler } from "./ldf/LdfTestCaseEvaluationHandler";

// tslint:disable:max-line-length
// tslint:disable:object-literal-sort-keys
module.exports = {

  // Ldf test suite
  'https://comunica.github.io/ontology-query-testing/ontology-query-testing.ttl#LdfQueryEvaluationTest':
    new LdfTestCaseEvaluationHandler(),

};
// tslint:enable:object-literal-sort-keys
// tslint:enable:max-line-length
